export default __webpack_public_path__ + "static/media/10004.e5688fa5.png";